import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./Shimmer.styled";
/**
 * A gray placeholder that stands in for a value still being fetched.
 *
 * Deliberately small: a size and a corner radius, nothing else. A caller that
 * needs three lines renders three, which keeps the sizing where the caller can
 * see what it is standing in for.
 */
export var Shimmer = function (props) {
    var _a = props.width, width = _a === void 0 ? "100%" : _a, _b = props.height, height = _b === void 0 ? 14 : _b, _c = props.radius, radius = _c === void 0 ? 4 : _c;
    return _jsx(S.Block, { "$width": width, "$height": height, "$radius": radius });
};
